export const saveAuthTokens = (payload: App.Token) => {
  localStorage.setItem("token", payload.token)
}
